<template>
    <el-tabs v-model="activeName" type="card" @tab-click="tabClick" v-loading.fullscreen.lock="fullscreenLoading">
        <el-tab-pane label="入库" name="first">

            <div style="padding:5px 5px 5px 5px">
                <div id="hello-hello">
                    <p style="display:inline;float: left;line-height: 22px;"><b>入库列表</b></p>
                    <p style="display:inline;float: right;line-height: 22px;margin: 5px 0;">
                        <el-button round type="success" @click="openDialog">新增入库</el-button>
                    </p>

                    <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                        <el-button round type="warning" @click="receive">接 收</el-button>
                        <span>-</span>
                    </p>
                </div>
            </div>

            <el-table :data="warehousingList" style="width: 100%" @select="selectClick" @row-click="rowClick"
                ref="wareHouseTable" highlight-current-row v-if="warehousingShowTable">

                <el-table-column type="selection" width="45" class="checkColumn">
                </el-table-column>

                <el-table-column prop="imgUrl" label="模具图片" min-width="10%">
                    <template slot-scope="scope">
                        <el-image :src="'https://' + imagePath + scope.row.imgUrl"
                            v-if="scope.row.imgUrl == '' ? false : true"></el-image>
                    </template>
                </el-table-column>

                <el-table-column prop="moldCode" label="模具编号" min-width="10%">
                </el-table-column>
                <el-table-column prop="productName" label="产品名称" min-width="10%">
                </el-table-column>
                <el-table-column prop="productAmount" label="出模数量" min-width="8%">
                </el-table-column>
                <el-table-column prop="takeTime" label="标准周期(s)" min-width="13%">
                </el-table-column>
                <el-table-column prop="productWeight" label="产品重量(g)" min-width="13%">
                </el-table-column>
                <el-table-column prop="material" label="材料配方" min-width="10%">
                </el-table-column>
                <el-table-column prop="housePosition" label="仓位号" min-width="10%">
                </el-table-column>
                <el-table-column prop="statusDes" label="状态" min-width="7%">
                </el-table-column>
                <el-table-column prop="remark" label="要求" min-width="9%">
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="250">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="primary" round size="small" style="">
                            更改
                        </el-button>

                        <el-button @click="lighting(scope.row)" type="primary" round size="small" style="">
                            定位
                        </el-button>
                        <el-button @click="outAndInClick(scope.row)" type="warning" round size="small"
                            v-if="scope.row.status == 0 ? false : true">
                            {{ scope.row.status === 1 ? '出库' : '入库' }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-dialog title="模具详情" :visible.sync="dialogFormVisible" width="860px">
                <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">

                    <div style="display: flex;">

                        <div style="width:43%;margin-left:44px">

                            <el-form-item label="模具图片" :label-width="formLabelWidth" prop="imgUrl">
                                <el-upload class="avatar-uploader" action="#" :http-request="upload"
                                    :show-file-list="false" :on-success="handleAvatarSuccess"
                                    :before-upload="beforeAvatarUpload">

                                    <img v-if="form.imgUrl" :src="form.imgUrl" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>

                                </el-upload>
                            </el-form-item>
                        </div>

                        <div style="width:50%;margin-right:35px">
                            <el-form-item label="模具编号" required :label-width="formLabelWidth" prop="moldCode">
                                <el-input v-model="form.moldCode" autocomplete="off" style="width:220px"
                                    :disabled="moldCodeDisable"></el-input>
                            </el-form-item>
                            <el-form-item label="产品名称" required :label-width="formLabelWidth" prop="productName">
                                <el-input v-model="form.productName" autocomplete="off" style="width:220px"></el-input>
                            </el-form-item>

                            <el-form-item label="出模数量" required :label-width="formLabelWidth" prop="productAmount">
                                <el-input-number v-model="form.productAmount" :step="1" :min="1"
                                    style="width:220px"></el-input-number>
                            </el-form-item>
                        </div>
                    </div>

                    <el-form-item label="标准周期(s)" :label-width="formLabelWidth" prop="takeTime">
                        <el-input v-model="form.takeTime" type="number" style="width:220px"></el-input>
                    </el-form-item>

                    <el-form-item label="产品重量(g)" :label-width="formLabelWidth" prop="productWeight">
                        <el-input v-model="form.productWeight" type="number" style="width:220px"></el-input>
                    </el-form-item>
                    <el-form-item label="材料配方" :label-width="formLabelWidth" prop="material">
                        <el-input v-model="form.material" autocomplete="off" style="width:220px"></el-input>
                    </el-form-item>

                    <el-form-item label="仓位号" :label-width="formLabelWidth" prop="housePosition">
                        <el-input v-model="form.housePosition" autocomplete="off" style="width:220px"></el-input>
                    </el-form-item>

                    <div style="width:350px;display: inline-block;"></div>

                    <el-form-item label="要求" :label-width="formLabelWidth">
                        <el-input v-model="form.remark" autocomplete="off" type="textarea"
                            style="width:570px"></el-input>
                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="$event => addWarehouse('ruleForm')">保存</el-button>
                </div>
            </el-dialog>

            <div>
                <p></p>
                <div id="hello-hello">
                    <p style="display:inline;float: left;line-height: 22px;"><b>操作列表</b></p>
                </div>

                <el-table :data="houseOperationList" row-key="id" style="width: 100%">
                    <el-table-column type="index" width="40">
                    </el-table-column>
                    <el-table-column prop="moldCode" label="模具编号" min-width="15%">
                    </el-table-column>
                    <el-table-column prop="operationTypeDes" label="操作" min-width="20%">
                    </el-table-column>

                    <el-table-column prop="operator" label="操作人" min-width="20%">
                    </el-table-column>
                    <el-table-column prop="createdTime" label="操作时间" min-width="45%">
                    </el-table-column>
                </el-table>

            </div>
        </el-tab-pane>

        <el-tab-pane label="出库" name="fourth">

            <div style="padding:5px 5px 5px 5px">
                <div id="hello-hello">
                    <p style="display:inline;float: left;line-height: 22px;"><b>出库列表</b></p>

                    <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                        <el-button round type="warning" @click="receive">接 收</el-button>

                    </p>
                </div>
            </div>

            <el-table :data="exWarehouseList" style="width: 100%" @select="selectClick" @row-click="rowClick"
                ref="wareHouseTable" highlight-current-row v-if="exWarehouseShowTable">

                <el-table-column type="selection" width="45" class="checkColumn">
                </el-table-column>
                <el-table-column prop="imgUrl" label="模具图片" min-width="10%">
                </el-table-column>
                <el-table-column prop="moldCode" label="模具编号" min-width="10%">
                </el-table-column>
                <el-table-column prop="productName" label="产品名称" min-width="10%">
                </el-table-column>
                <el-table-column prop="productAmount" label="出模数量" min-width="8%">
                </el-table-column>
                <el-table-column prop="takeTime" label="标准周期(s)" min-width="13%">
                </el-table-column>
                <el-table-column prop="productWeight" label="产品重量(g)" min-width="13%">
                </el-table-column>
                <el-table-column prop="material" label="材料配方" min-width="10%">
                </el-table-column>
                <el-table-column prop="housePosition" label="仓位号" min-width="10%">
                </el-table-column>
                <el-table-column prop="statusDes" label="状态" min-width="7%">
                </el-table-column>
                <el-table-column prop="remark" label="要求" min-width="9%">
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">

                        <el-button @click="outAndInClick(scope.row)" type="warning" round size="small"
                            v-if="scope.row.status == 2 ? false : true">
                            {{ scope.row.status === 1 ? '出库' : '入库' }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div>
                <p></p>
                <div id="hello-hello">
                    <p style="display:inline;float: left;line-height: 22px;"><b>操作列表</b></p>
                </div>

                <el-table :data="houseOperationList" row-key="id" style="width: 100%">
                    <el-table-column type="index" width="40">
                    </el-table-column>
                    <el-table-column prop="moldCode" label="模具编号" min-width="15%">
                    </el-table-column>
                    <el-table-column prop="operationTypeDes" label="操作" min-width="20%">
                    </el-table-column>
                    <el-table-column prop="operator" label="操作人" min-width="20%">
                    </el-table-column>
                    <el-table-column prop="createdTime" label="操作时间" min-width="45%">
                    </el-table-column>
                </el-table>
            </div>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
    name: "Warehouse",
    data() {
        return {
            gc: 0,
            token: this.getToken(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),
            imagePath: this.getImagePath(),
            activeName: 'first',
            fullscreenLoading: false,

            warehousingShowTable: true,
            exWarehouseShowTable: false,
            warehousingList: [],
            exWarehouseList: [],
            houseOperationList: [],
            dialogFormVisible: false,

            statusSearch: 1,
            form: {
                id: '',
                imgUrl: '',
                imgFile: {},
                moldCode: '',
                productName: '',
                productAmount: '',
                takeTime: '',
                productWeight: '',
                material: '',
                housePosition: '',

                status: 1,
                remark: '',
            },
            // assemblyProgress: 0,
            // polishProgress: 0,
            formLabelWidth: '120px',
            moldCodeDisable: false,

            rules: {
                productName: [
                    { required: true, message: '请输入产品名称', trigger: 'blur' },
                    { required: true, message: '请输入产品名称', trigger: 'change' }
                ],
                moldCode: [
                    { required: true, message: '请输入模具编号', trigger: 'blur' },
                    { required: true, message: '请输入模具编号', trigger: 'change' }
                ],
                productAmount: [
                    { required: true, message: '请输入出模数量', trigger: 'blur' },
                    { required: true, message: '请输入出模数量', trigger: 'change' }
                ]
            },
            pageIndex: 0,
            total: 0,
            pageCount: 0,
            selectedRow: {}
        }
    },
    methods: {
        lighting(row) {

            this.$axios({
                method: "post",
                url: "/shiro/sendMessage",
                data: {
                    housePosition:row.housePosition
                },
                headers: {

                }
            }).then(result => {

            })
        },
        tabClick(tab, event) {

            // console.log(tab)
            // console.log(event)

            this.fullscreenLoading = true;

            if (tab._props.name == 'fourth') {
                this.exWarehouseShowTable = true
                this.warehousingShowTable = false

                this.statusSearch = 2
                this.getAll(this.statusSearch)
            } else {
                this.warehousingShowTable = true
                this.exWarehouseShowTable = false

                this.statusSearch = 1
                this.getAll(this.statusSearch)
            }

            setTimeout(() => {
                this.fullscreenLoading = false;
                this.gc = 0
            }, 900);
        },
        handleAvatarSuccess(res, file) {

            this.imgUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {

            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        selectClick(selection, row) {

            this.$refs.wareHouseTable.clearSelection()
            this.$refs.wareHouseTable.toggleRowSelection(row)


            this.selectedRow = row

            this.getAllHouseOperation(row.moldCode)
        },
        rowClick(row) {
            //console.log(row)

            this.$refs.wareHouseTable.clearSelection()
            this.$refs.wareHouseTable.toggleRowSelection(row)


            this.selectedRow = row

            this.getAllHouseOperation(row.moldCode)
        },
        handleClick(row) {
            // console.log(row);
            this.form.id = row.id

            this.form.moldCode = row.moldCode
            this.form.productName = row.productName
            this.form.productAmount = row.productAmount

            this.form.takeTime = row.takeTime
            this.form.productWeight = row.productWeight
            this.form.material = row.material
            this.form.housePosition = row.housePosition

            this.form.status = row.status
            this.form.remark = row.remark

            this.moldCodeDisable = true
            this.dialogFormVisible = true
        },
        receive() {
            // this.statusSearch = 0
            // console.log('this.selectedRow')
            // console.log(this.selectedRow)

            if (this.selectedRow.moldCode == '' || (this.selectedRow.status != 0 && this.selectedRow.status != 2)) {
                this.$message({
                    type: 'info',
                    message: '请先选择需要接收的模具'
                })
                return
            }

            this.outAndInClick(this.selectedRow)
        },
        outAndInClick(row) {

            this.$confirm('确定要执行此操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.statusSearch = row.status

                const form = new FormData()
                form.append('id', row.id)
                form.append('moldCode', row.moldCode)
                form.append('status', this.statusSearch == 0 ? 1 : this.statusSearch == 1 ? 2 : this.statusSearch == 2 ? 3 : 0)

                form.append('operatorId', this.userId)
                form.append('companyId', this.companyId)

                this.$axios({
                    method: "post",
                    url: "/shiro/warehouse/add",
                    data: form,
                    headers: {
                        token: this.token
                    }
                }).then(result => {

                    const data = result.data

                    if (data.status != 200) {
                        this.$message(data.msg)
                        return
                    }

                    this.getAll(this.statusSearch)
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });

        },
        openDialog() {

            this.form.moldCode = ''
            this.form.productName = ''

            this.form.productAmount = ''
            this.form.takeTime = ''
            this.form.productWeight = ''
            this.form.material = ''
            this.form.housePosition = ''

            // this.form.createdTime = new Date()

            this.form.status = 0
            this.form.remark = ''

            this.moldCodeDisable = false
            this.dialogFormVisible = true

        },
        upload(f) {

            this.form.imgFile = f.file
        },
        addWarehouse(formName) {

            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // alert('submit!');
                    const form = new FormData()
                    form.append('id', this.form.id)

                    // form.append('imgFile', this.imgFile)

                    let arr = Object.keys(this.form.imgFile)
                    if (arr.length == 0) {

                        form.append('imgFile', new File([], 'file'))
                    } else {
                        form.append('imgFile', this.form.imgFile)
                    }


                    form.append('moldCode', this.form.moldCode)

                    form.append('productName', this.form.productName)
                    form.append('productAmount', this.form.productAmount)
                    form.append('takeTime', this.form.takeTime)

                    form.append('productWeight', this.form.productWeight)
                    form.append('material', this.form.material)
                    form.append('housePosition', this.form.housePosition)

                    form.append('status', this.form.status)
                    form.append('remark', this.form.remark)
                    form.append('operatorId', this.userId)
                    form.append('companyId', this.companyId)

                    this.$axios({
                        method: "post",
                        url: "/shiro/warehouse/add",
                        data: form,
                        headers: {
                            token: this.token
                        }
                    }).then(result => {

                        const data = result.data

                        if (data.status != 200) {
                            this.$message(data.msg)
                            return
                        }

                        this.dialogFormVisible = false
                        this.getAll(this.statusSearch)
                    })
                } else {
                    return false;
                }
            });

        },
        searchByStatus(val) {
            //console.log('bbb')
            //console.log(val)
            this.getAll(val)
        },
        getAll(val) {
            // const formData = new FormData()
            // formData.append('status', val)
            // formData.append('assemblyProgress', 0)
            // formData.append('companyId', this.companyId)
            // formData.append('pageIndex', this.pageIndex)
            // formData.append('pageNum', 10)

            this.$axios({
                method: "post",
                url: "/shiro/warehouse/getAll",
                data: {
                    companyId: this.companyId,
                    status: val
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    });
                    return
                }

                if (val == 0 || val == 1) {
                    this.warehousingList = data.data

                    for (let i in this.warehousingList) {

                        if (this.warehousingList[i].status == 0) {
                            this.warehousingList[i].statusDes = '待接收'
                        } else if (this.warehousingList[i].status == 1) {
                            this.warehousingList[i].statusDes = '已入库'
                        }
                    }
                } else {
                    this.exWarehouseList = data.data

                    for (let i in this.exWarehouseList) {

                        if (this.exWarehouseList[i].status == 2) {
                            this.exWarehouseList[i].statusDes = '待接收'
                        } else if (this.exWarehouseList[i].status == 3) {
                            this.exWarehouseList[i].statusDes = '已出库'
                        }
                    }
                }

                // this.total = this.warehousingList[0].total
                // this.pageCount = this.total % 10 == 0 ? this.total % 10 : this.total % 10 + 1
            })
        },
        getAllHouseOperation(value) {
            // console.log('getAllHouseOperation()')
            // console.log(value)

            if (this.statusSearch != 0 && this.statusSearch != 1) {
                this.warehousingList = this.exWarehouseList
            }

            if (Object.keys(this.warehousingList).length != 0) {
                const index = this.warehousingList.findIndex(obj => obj.moldCode == value)
                // console.log('index')
                // console.log(index)

                this.houseOperationList = this.warehousingList[index].houseOperationList

                console.log(this.houseOperationList)

                for (let i in this.houseOperationList) {
                    if (this.houseOperationList[i].operationType == 0) {
                        this.houseOperationList[i].operationTypeDes = '入库申请'
                    } else if (this.houseOperationList[i].operationType == 1) {
                        this.houseOperationList[i].operationTypeDes = '入库'
                    } else if (this.houseOperationList[i].operationType == 2) {
                        this.houseOperationList[i].operationTypeDes = '出库申请'
                    } else {
                        this.houseOperationList[i].operationTypeDes = '出库'
                    }
                    this.houseOperationList[i].createdTime = this.$moment(this.houseOperationList[i].createdTime).format("YYYY-MM-DD")
                }
            }
        },
        pageClick(currentPage) {
            // console.log('pageClick()')
            // console.log(currentPage)
            this.pageIndex = (currentPage - 1) * 10
            this.getAll(this.statusSearch)
        }
    },
    mounted() {

        this.getAll(this.statusSearch)

    },
    updated() {
        console.log('Warehouse.vue-->updated')

        var checkBoxEle = document.getElementsByClassName("el-checkbox")
        // console.log('checkBoxEle')
        // console.log(checkBoxEle)
        checkBoxEle[0].innerHTML = ''

        if (this.gc == 0) {
            console.log('gc: ')


            if (this.$refs.wareHouseTable != null && this.$refs.wareHouseTable.tableData.length > 0) {

                this.$refs.wareHouseTable.toggleRowSelection(this.$refs.wareHouseTable.tableData[0])
                this.selectedRow = this.$refs.wareHouseTable.tableData[0]

                this.form.moldCode = this.$refs.wareHouseTable.tableData[0].moldCode

                this.getAllHouseOperation(this.form.moldCode)
            }

        }
        this.gc++
    }
}
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

#order-header {
    height: 70px;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}
</style>